// extracted by mini-css-extract-plugin
module.exports = {"center":"center__2ztmI","content":"content__1giuT"};